import { render, staticRenderFns } from "./ProjectUserCom.vue?vue&type=template&id=34c02040&"
import script from "./ProjectUserCom.vue?vue&type=script&lang=ts&"
export * from "./ProjectUserCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports